<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :label="selectLabel"
    :value="value"
    @input="(recurringPayment) => $emit('input', recurringPayment)"
    :reduce="option => option"
  >
    <template #option="option">
      <div>
        {{ option.description }}
      </div>
      <div class="font-size-sm text-secondary">
        <money-format
          class="d-inline"
          :value="option.amount && option.amount.amount"
          :currency-code="option.amount && option.amount.currency"
          subunits-value
        />
        <span v-if="option.total && option.total.amount"> · Total: </span>
        <money-format
          v-if="option.total && option.total.amount"
          class="d-inline"
          :value="option.total.amount"
          :currency-code="option.total.currency"
          subunits-value
        />
      </div>
    </template>
    <template #selected-option="option">
      <span>{{ option.description }}</span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'RecurringPaymentsSelect',
  props: {
    value: Object,
    userId: Number,
    id: {
      type: String,
      default: 'recurring-payment',
    },
    selectLabel: {
      type: String,
      default: 'description',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: String,
    filterParams: {
      type: Object,
      default: () => new Object(),
    },
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      if (!this.userId) {return;}
      this.$recurringPaymentsAPI.getUserRecurringPayments(this.userId, this.filterParams).then((response) => {
        this.options = response.recurringPayments;
      });
    },
  },
};
</script>

